"use client";

import { db } from "@/helpers/firebase/firebase";
import { ExtendedLineItem } from "@/models/pass";
import { startLoader, stopLoader } from "@/redux/features/app-slice";
import { AppDispatch, useAppSelector } from "@/redux/store";
import { LineItem, Session } from "@stripe/firestore-stripe-payments";
import { addDoc, collection, onSnapshot } from "firebase/firestore";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

type RedirectToStripeProps = {
  lineItems: ExtendedLineItem[];
};

const customersCollection = "customers";

const subcollections = {
  checkoutSessionsCollection: "checkout_sessions",
};

export default function RedirectToStripe({
  lineItems,
}: RedirectToStripeProps) {
  const currentPath = usePathname();
  const router = useRouter();
  const dispatch = useDispatch<AppDispatch>();
  const auth = useAppSelector((store) => store.appReducer.auth);
  let count = 0;

  useEffect(() => {
    if (!auth.isAuth || count > 0) {
      return;
    }
    dispatch(startLoader("Redirecting to stripe checkout"));
    count++;
    const checkoutSessionRef = collection(
      db,
      customersCollection,
      auth.user?.uid ?? "",
      subcollections.checkoutSessionsCollection
    );

    const createCheckoutSesstionPayload = {
      line_items: lineItems,
      success_url: `${window.location.origin}${currentPath}/success?session_id={CHECKOUT_SESSION_ID}`,
      cancel_url: `${window.location.origin}`,
      mode: "payment",
    } as any;

    addDoc(checkoutSessionRef, createCheckoutSesstionPayload).then((docRef) => {

      const unsubscribe = onSnapshot(docRef, (snap) => {
        const { url } = snap.data() as Session;
        if (url) {
          dispatch(stopLoader());
          unsubscribe();
          const slug = url.split("/").slice(-1);
          router.replace(`/stripe-checkout/${slug}`);
        }
      });
    });
  }, [auth]);

  return <></>;
}
